// const TransactionListPage = () => import('./list/TransactionListPage.vue');

import TransactionListPage from "./list/TransactionListPage.vue";

const routes = [
  {
    path: '/history',
    name: 'history',
    component: TransactionListPage,
    meta: {
      title: 'Coupons',
      requiresAuth: true
    }
  }
];

export default routes;
